import { takeEvery, call, put } from "redux-saga/effects";
import { getSpecialities, setSpecialities } from "../constants";
import { getAllSpecialitiesData } from "../api/specialities.api";

function* handleGetSpecialites() {
  try {
    const result: { id: number; name: string; status?: boolean }[] = yield call(
      getAllSpecialitiesData
    );
    yield put({ type: setSpecialities, specialities: result });
  } catch (error) {
    console.log("Error: ", error);
  }
}

export default function* getAllSpecialities() {
  yield takeEvery(getSpecialities, handleGetSpecialites);
}
